import { render, staticRenderFns } from "./backSetting.vue?vue&type=template&id=363acf6e&scoped=true&"
import script from "./backSetting.vue?vue&type=script&lang=js&"
export * from "./backSetting.vue?vue&type=script&lang=js&"
import style0 from "./backSetting.vue?vue&type=style&index=0&id=363acf6e&prod&lang=scss&scoped=true&"
import style1 from "./backSetting.vue?vue&type=style&index=1&id=363acf6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363acf6e",
  null
  
)

export default component.exports